import { useCallback, useState } from 'react';

interface PaginationConfig {
  totalPages?: number;
  initialPage?: number;
}

type SetPage = (page: number) => void;

export const usePagination = ({
  totalPages = 1,
  initialPage = 1,
}: PaginationConfig): [page: number, setPage: SetPage] => {
  const [page, setPage] = useState(initialPage);

  const onPageChange = useCallback(
    (page: number) => {
      if (page < 1 || page > totalPages) {
        return;
      }

      setPage(page);
    },
    [totalPages],
  );

  return [page, onPageChange];
};
